export default "__VITE_ASSET__3zQJ0Jej__"